import Vue from 'vue'
import App from './App.vue'
import './plugins/axios'
import VueClipboards from 'vue-clipboard2'
Vue.use(VueClipboards);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
